import React from 'react';
import '../less/main.less';
import DOMPurify from 'utils/sanitize';

export default function template() {
  const { text, className, maxWidth } = this.props;

  return (
    <div className={`text-block-new ${className ? className : ''}`}>
      <div className="container">
        <div className="text-block-new__body" style={{ ...(maxWidth && { maxWidth }) }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(text))}}></div>
      </div>
    </div>
  );
}

